"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _getWindow = _interopRequireDefault(require("./getWindow"));

function scrollLeft(node, val) {
  var win = (0, _getWindow["default"])(node);
  var left = node.scrollLeft;
  var top = 0;

  if (win) {
    left = win.pageXOffset;
    top = win.pageYOffset;
  }

  if (val !== undefined) {
    if (win) {
      win.scrollTo(val, top);
    } else {
      node.scrollLeft = val;
    }
  }

  return left;
}

var _default = scrollLeft;
exports["default"] = _default;
module.exports = exports.default;